import Location from "@/scenes/location";
import GameApp from "../../../index";

export class LocationActionsHandlers {
  static async handle(data) {
    // Handle actions based on the provided data
    const scene = GameApp.game.currentScene as Location;

    switch (data.action) {
      case "wall-update":
        await scene.roomTileMap.loadWallPattern(data.pattern);
        scene.roomTileMap.changeWallPattern();
        break;

      case "name-update":
        scene.locationInfo.setTitle(data.title)
        break;
    }
  }
}
